import React from 'react';

const CartPromoCode = ({
  showInput,
  shouldShowPromoCodeInput,
  validateCode,
  isLoadingPromoCode,
  updatePromoCode,
  isValidPromoCode,
  isInvalidPromoCode
}) => {
  if (isValidPromoCode) {
    return (
      <div className="cart-promoCode-container">
        <p className="cart-promoCode-response valid">Votre Code est appliqué !</p>
      </div>
    );
  } else if (isInvalidPromoCode && !shouldShowPromoCodeInput) {
      return (
        <div className="cart-promoCode-container">
          <p className="cart-promoCode-response invalid">
            Votre code est erroné ! -
            <button
              className="cart-promoCode-btn"
              onClick={showInput}
              type="button"
            >
              Réessayer
            </button>
          </p>
        </div>
      );
    }

  return (
    <div className="cart-promoCode-container">
      {shouldShowPromoCodeInput ? (
        <div className="cart-promoCode-subContainer">
          <form action="" onSubmit={event => event.preventDefault()}>
            <input
              className="cart-promoCode-input"
              type="text"
              placeholder="Code Promo"
              disabled={isLoadingPromoCode}
              onChange={updatePromoCode}
            />
            <button
              className={`cart-promoCode-input-validate-btn ${
                isLoadingPromoCode ? "checking" : ""
              }`}
              type="button"
              onClick={validateCode}
            >
              <span className="lpc-txt">Valider</span>
              <span className="loading-spin" />
            </button>
          </form>
        </div>
      ) : (
        <button
          className="cart-promoCode-btn"
          onClick={showInput}
          type="button"
        >
          Code Promo ?
        </button>
      )}
    </div>
  );
};

export default CartPromoCode;



// WEBPACK FOOTER //
// ./src/components/buy/Cart/CartPromoCodeBtn.js